let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bAyJY")).then(() => parcelRequire('2bGC8'));